import { HelpCircle, Mail } from 'lucide-react';
import { PageShell } from '@/components/layout/PageShell';
import { ERROR_CATALOG } from '@/lib/errorCodes';

/**
 * Central de ajuda: explica cada código de erro exibido pela plataforma
 * (item do relatório de testes: "tela onde explicasse cada um dos códigos").
 */
export function ErrorCodesPage() {
  return (
    <PageShell
      title="Central de ajuda — códigos de erro"
      subtitle="Quando algo dá errado, mostramos um código. Aqui está o que cada um significa."
    >
      <div className="card p-5 mb-4 flex items-start gap-3">
        <HelpCircle className="w-5 h-5 text-brand-700 shrink-0 mt-0.5" />
        <p className="text-sm text-ink-muted">
          Ao contatar o suporte, informe o código exibido na tela — ele nos diz
          exatamente o tipo de falha, agilizando a resposta. E-mail do suporte:{' '}
          <a href="mailto:bemyndstore@gmail.com" className="text-brand-700 underline inline-flex items-center gap-1">
            <Mail className="w-3.5 h-3.5" />bemyndstore@gmail.com
          </a>
        </p>
      </div>

      <div className="card divide-y divide-border">
        {Object.entries(ERROR_CATALOG).map(([code, description]) => (
          <div key={code} className="flex items-start gap-4 px-5 py-3.5">
            <span className="font-mono text-sm font-bold text-ink bg-surface-subtle rounded-lg px-2.5 py-1 shrink-0">
              {code}
            </span>
            <p className="text-sm text-ink-muted pt-1">{description}</p>
          </div>
        ))}
      </div>

      <p className="text-xs text-ink-soft mt-4">
        Dica: erros de conexão (NET-004) geralmente se resolvem recarregando a
        página ou verificando sua internet. Se um código persistir, fale com o suporte.
      </p>
    </PageShell>
  );
}
